import { createStore, createEffect } from 'effector'

export const loadContractFx = createEffect()

export const $contracts = createStore({})
